module.exports = __webpack_public_path__ + "img/search-by-ipv4-prefix.4f58668e.png";